import {Component, HostListener, OnInit} from '@angular/core';
import {TranslateService, TranslateModule} from '@ngx-translate/core';
import {ThemeService} from '../themeService';
import {CookieService} from '../cookieService';
import {ActivatedRoute} from '@angular/router';
import {APP_CONFIG, ConfigService} from '../configService';
import {LocationStrategy, CommonModule} from '@angular/common';
import { CookiePopinComponent } from '../cookie-popin/cookie-popin.component';
import { NavigationService } from '../services/navigation.service';
import {GoogleAnalyticsService} from '../services/analytics/google-analytics.service';

@Component({
  selector: 'app-cookie-manager',
  templateUrl: './cookie-manager.component.html',
  styleUrls: ['./cookie-manager.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, CookiePopinComponent]
})
export class CookieManagerComponent implements OnInit {

  openPopin = true;
  havePopin = true;
  errorRedirect = false;
  loadEnd = false;
  pageDetails: any;
  param: any;
  isTranslationLoaded = false;
  alternateDisplayForMarkets = false;
  returnUrl = '';
  lang='';
  market='';
  ssid='';
  version='';

  constructor(private readonly translate: TranslateService,
              private readonly themeService: ThemeService,
              private readonly configService: ConfigService,
              private readonly route: ActivatedRoute,
              private readonly locationStrategy: LocationStrategy,
              private readonly cookieService: CookieService,
              private readonly navigationService: NavigationService) { }

  @HostListener('window:popstate', ['$event']) onPopState(): void {
    if (this.havePopin) {
      if (this.openPopin) { // if click back and popin open go back
        this.navigationService.setHref(this.returnUrl);
      }
      this.openPopin = true;
    } else {
      this.navigationService.setHref(this.returnUrl);
    }
  }

  ngOnInit(): void {
    // version.txt
    history.pushState(null, '', location.href);
    this.locationStrategy.onPopState(() => {
      history.pushState(null, '', location.href);
    });


    this.route.queryParamMap.subscribe((query: any) => {
      this.returnUrl = query.params.return_url;
      if (query.params.apikey) {
        this.errorRedirect = !query.params.no_error_redirect;
        const apiKey = query.params.apikey;
        this.version = query.params.version;
        const country = query.params.country;
        const clientVersion = query.params['Gseb-App-Version'];
        this.lang = query.params.lang;
        this.ssid = query.params.ssid ;
        if (!this.lang) { this.loadEnd = true; this.error('4', 'errorNolanguageParameter'); }
        if (!apiKey) { this.loadEnd = true; this.error('1', 'error.apikey'); }
        if (!this.version) { this.loadEnd = true; this.error('2', 'error.version'); }
        if (!country) { this.loadEnd = true; this.error('3', 'error.country'); }

        this.cookieService.getClient(apiKey, this.lang, country, clientVersion).subscribe( (client) => {
          if (!client) { this.error('6', 'error.client'); }
          //If we get another market, the fallback client is used
          if (this.market !== client.markets[0].name) {
            this.lang = client.markets[0].locales[0].lang;
            this.configService.getTranslate(this.lang).subscribe( (json) => {
              if (!json) { this.loadEnd = true; this.error('5', 'errorNoTranslationFound'); }
              this.translate.setTranslation(this.lang, json, true);
              this.translate.setFallbackLang(this.lang);
              this.setHtmlLangProperty(this.lang);

              this.isTranslationLoaded = true;
            }, error1 => { this.loadEnd = true; this.error('5', error1.message.toString()); } );
          }
          this.market = client.markets[0].name;
          const brand = client.markets[0].rcuBrand;
          this.themeService.load(brand);
          this.cookieService.getCookiePageDetails(apiKey, this.version, this.market, this.lang).subscribe( (pageDetails) => {
            if (!pageDetails) { this.error('7', 'error.pageDetails'); }
            this.pageDetails = pageDetails;
            this.alternateDisplayForMarkets = !APP_CONFIG.alternateDisplayForMarketsList.some( (mket) => mket === this.market);
            if (query.params.trackerSelectionLite) {
              this.param = JSON.parse(atob(query.params.trackerSelectionLite));
              this.havePopin = false;
              this.openPopin = false;
            } else { // if no parameters
              this.param = { trackers: []};
              this.pageDetails.cookiePurposes.forEach( (purposes: any) => {
                const cookie: any = { cookiePurposes: purposes.key};
                if (purposes.isMandatory) {
                  cookie.state = true;
                }
                this.param.trackers.push( cookie );
              });
            }
            this.loadEnd = true;
          }, error1 => { this.loadEnd = true; this.error('7', error1.message.toString()); } );
        }, error1 => { this.loadEnd = true; this.error('6', error1.message.toString()); } );
      }
    });
  }

  popinAction(input: true | false | string): void {
    if (input === 'openAll') { // open all
      this.pageDetails.cookiePurposes.map( (cookie: any) => cookie.open = true);
      this.openPopin = false;
    } else if (input === true) { // agree all
      this.allAccept();
      this.save();
    } else if (input === false) { // agree nothing
      this.allReject();
      this.save();
    } else { // see details
      this.openPopin = false;
    }
  }

  allAccept(): void {
    this.param.trackers.map( (param: any) => {
      param.state = true;
      return param;
    });
  }

  allReject(): void {
    this.param.trackers.map( (param: any) => {
      param.state = false;
      return param;
    });
  }

  save(): void {
    // check mandatory field
    this.param.trackers.map( (param: any) => {
      if (this.pageDetails.cookiePurposes.some((cook: any) => (param.cookiePurposes === cook.key) && cook.isMandatory)) {
        param.state = true;
      }
      return param;
    });
    this.param.expiration = Date.now() + Number(this.pageDetails.validity);

    let consentValues = '';
    this.param.trackers.map( (param: any) => {
      if (param.cookiePurposes === 'audience'){
        let consent =  param.state ? '1' : '0';
        consentValues += 'audience : ' + consent;
      }
      if (param.cookiePurposes === 'advertising'){
        let consent =  param.state ? '1' : '0';
        consentValues += ' | advertising : ' + consent;
      }
      if (param.cookiePurposes === 'custom'){
        let consent =  param.state ? '1' : '0';
        consentValues += ' | custom : ' + consent;
      }
    });

    GoogleAnalyticsService.setCustomDimension('app_lang', this.lang);
    GoogleAnalyticsService.setCustomDimension('app_version', this.version);
    GoogleAnalyticsService.setCustomDimension('app_ssid', this.ssid);
    GoogleAnalyticsService.setCustomDimension('app_market', this.market);
    GoogleAnalyticsService.sendEvent(
      { event: 'privacy', content_name: 'user choice popin', content_id: consentValues }
    );

    // Redirect with parameters
    const separator = (this.returnUrl.includes('?') || this.returnUrl.includes('%3F')) ? '&' : '?';
    this.navigationService.setHref(`${this.returnUrl}${separator}trackerSelectionLite=${btoa(JSON.stringify(this.param))}`);
  }

  exit(): void {
    history.back();
  }

  error(errorCode: string, errorDescription: string): void {
    if (this.errorRedirect) {
      this.navigationService.setHref(
        this.returnUrl + ( (this.returnUrl.includes('?') || this.returnUrl.includes('%3F')) ? '&' : '?' ) +
        'cookie_error=' + errorCode + '&cookie_error_description=' + this.translate.instant(errorDescription));
    } else {
      console.error(errorCode, this.translate.instant(errorDescription));
    }
  }

  toTime(time: string): string {
    const constMonth = 1000 * 60 * 60 * 24 * 30.41 ;
    return this.translate.instant('duration').replace( '%time%', Math.floor(Number(time) / constMonth) ) ;
  }

  getParam(key: string): any {
    const paramValue = this.param.trackers.find( (param: any) => param.cookiePurposes === key);
    if (paramValue) {
      if (paramValue.state === true || paramValue.state === false) {
        return paramValue.state;
      }
    }
    return null;
  }

  toggle(key: string): void {
    this.param.trackers.map( (param: any) => {
      if (param.cookiePurposes === key) {
        param.state = !param.state;
      }
      return param;
    });
  }

  isSomeUnselected(): any {
    return this.param.trackers.some( (tracker: any) => tracker.state !== true && tracker.state !== false );
  }

  private setHtmlLangProperty(lang: string): void {
    const tagTarget = document.getElementsByTagName('html');
    if (tagTarget.length) {
      tagTarget[0].setAttribute('lang', lang);
    }
  }

}
